<em-main>
  <div class="layout--row">
    <h3 class="layout--third-width" i18n>Mon profil</h3>

    <div class="layout--full-width layout--column layout--gap-larger">
      <em-broker-information-section></em-broker-information-section>
      <em-password></em-password>
      <em-humania-section></em-humania-section>
    </div>
  </div>
</em-main>
